import { render, staticRenderFns } from "./WidgetsWrapper.vue?vue&type=template&id=352e431d"
import script from "./WidgetsWrapper.vue?vue&type=script&lang=ts"
export * from "./WidgetsWrapper.vue?vue&type=script&lang=ts"
import style0 from "./WidgetsWrapper.vue?vue&type=style&index=0&id=352e431d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports